import React from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './MainBanner.module.scss';
import lotterLapImage from "../../assets/MainBannerImages/laptopwithscreen.png"

function Mainbanner({
  BackImage,
  LogoImage,
  logoIcon,
  casieImage,
  titlebannerImage1,
  titleBannerImage2,
  titleBannerImage3,
  TitleIcon,
  link,
  lotteryLap
}) {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (link) {
      navigate(link);
    }
  };

  return (
    <div className={`${classes.mainBannerStyle} ${classes[BackImage]}`}>
      {LogoImage ? (
        <img
          src={LogoImage}
          alt="logo Icon"
          className={`${classes.logoIconStyle} ${classes[logoIcon]}`}
        />
      ) : (
        ''
      )}
      {casieImage ? (
        <img
          src={casieImage}
          alt="person Icon"
          className={classes.casieIconStyle}
        />
      ) : (
        ''
      )}
      {lotteryLap ? (
        <img
          src={lotterLapImage}
          alt="lap Icon"
          className={classes.LotteryImage}
        />
      ) : (
        ''
      )}
      {titlebannerImage1 ? (
        <img
          src={titlebannerImage1}
          alt="title Icon"
          className={`${classes.TitleIconStyle1} ${classes[TitleIcon]}`}
        />
      ) : (
        ''
      )}
      {titleBannerImage2 ? (
        <img
          src={titleBannerImage2}
          alt="title Icon"
          className={`${classes.TitleIconStyle2} ${classes[TitleIcon]}`}
        />
      ) : (
        ''
      )}
      {titleBannerImage3 ? (
        <img
          src={titleBannerImage3}
          alt="title Icon"
          className={`${classes.TitleIconStyle3} ${classes[TitleIcon]}`}
        />
      ) : (
        ''
      )}
      {TitleIcon === 'jackPot' ? (
        <div className={classes.textPosition}>
          <span className={classes.textImage}>
            WIN BIG WITH OUR
            <span className={classes.inlineText}> LOTTERY GAMES!</span>
          </span>
          <span className={classes.secondTextImage}>
            Experience the thrill of winning with our
            <span className={classes.inlineText1}>
              exciting online lottery studio!
            </span>
          </span>
        </div>
      ) : TitleIcon === 'sportsBetting' ? (
        <div className={classes.textPosition}>
          <span className={classes.textImage}>SPORTS BETTING</span>
          <span className={classes.secondTextImage}>
            Bet on your favorite sports with real-time
            <span className={classes.inlineText1}>
              updates, competitve odds, and a
            </span>
            <span className={classes.inlineText1}>seamless experience</span>
          </span>
        </div>
      ) : (
        ''
      )}

      <button className={classes.btnStyle} onClick={handleButtonClick}>
        Play Now
      </button>
    </div>
  );
}

export default Mainbanner;
